import { makeQueryStringFromObject } from '../apiHelper'
import apiClient from './apiClient'

export const getAllSections = (_, parameters) => apiClient.get(null, `public/sections${makeQueryStringFromObject(parameters)}`)